<template>
  <component :is="data === undefined ? 'div' : 'b-card'">

    <!-- Alert: No item found -->
    <b-alert variant="danger" :show="data === undefined">
      <h4 class="alert-heading">
       {{ $t('Error fetching data')}}
      </h4>
      <div class="alert-body">
        {{ $t('No item found with this id.')}}
      </div>
    </b-alert>

    <div class="loading_page" v-if="requestStatus">
      <orbit-spinner
          :animation-duration="1000"
          :size="100"
          :color="'#0e96b1'"
      />
    </div>
      <info-form :data=data :errors=errors @onSubmit=onSubmit />
  </component>
</template>

<script>
import {
  BTab, BTabs, BCard, BAlert, BLink, BButton, BFormGroup, BFormInput, BForm, BFormTextarea,
    BFormInvalidFeedback
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import router from '@/router'
import client from '../client'

import { OrbitSpinner } from 'epic-spinners'
import vSelect from 'vue-select'
import InfoForm from '../form'

export default {
  components: {
    BTab,
    BTabs,
    BFormTextarea,
    BFormInvalidFeedback,
    vSelect,
    BCard,
    BButton,
    BFormGroup,
    BFormInput,
    BForm,
    BAlert,
    OrbitSpinner,
    BLink,
    InfoForm
  },
  setup(props, { root }) {

    const data = ref({})

    const errors = ref({})

    const requestStatus = ref(true)

    const onSubmit = () => {

      requestStatus.value = true
      errors.value = {}

      client.edit(data.value).then(res => {
        requestStatus.value = false
        toaster(root.$i18n.t('item Updated successfully'),
            'success',
            root.$i18n.t('Success'))

      }).catch(res => {
        errors.value = res.response.data
      }).finally(() => {
        requestStatus.value = false
      })
    }

    const toaster = (msg, variant, title) => {
      root.$root.$bvToast.toast(msg, {
        title,
        variant,
        solid: true,
      })
    }

    client.fetchOne({ id: router.currentRoute.params.id })
      .then(response => {
        data.value = response.data.workShift
        requestStatus.value = false
      })
      .catch(error => {
        console.log(error)
        if (error.response.status === 404) {
          data.value = undefined
          requestStatus.value = false
        }
      })

    return {
      data,
      requestStatus,
      errors,
      onSubmit
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
#add-new-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
